var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desktop-validate-container",class:{ 'ios-device': _vm.device === 'ios' }},[_c('div',{staticClass:"desk-icon"}),_c('div',{staticClass:"title"},[_vm._v("Apphi For Desktop")]),_c('div',{staticClass:"des"},[_vm._v("Go to desktop.apphi.com to use Apphi on desktop/PC")])])
}
var staticRenderFns = []

export { render, staticRenderFns }